import {GET_UNSPLASH,CLOSE_UNSPLASH} from '../actions/actionTypes'

export default (state = {data:{}}, action) => {
    switch (action.type) {

        case GET_UNSPLASH:
            // console.log(action.payload);
            return action.payload;

        case CLOSE_UNSPLASH:
            // console.log(action.payload);
            return {data:{}};

        default:
            return state;
    }
};